import React from 'react';

export const SlotOpen = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            xmlns='http://www.w3.org/2000/svg'
            width='22'
            height='22'
            viewBox='0 0 22 22'
            fill='none'>
            <path
                d='M10 18.4377H1M18 18.4377L11.242 20.1267C11.0946 20.1635 10.9408 20.1662 10.7922 20.1346C10.6436 20.103 10.5042 20.038 10.3845 19.9445C10.2648 19.851 10.1679 19.7315 10.1013 19.595C10.0347 19.4585 10 19.3086 10 19.1567V2.9997C10.0002 2.69588 10.0696 2.3951 10.203 2.12211C10.3363 1.84913 10.5301 1.61011 10.7697 1.42321C11.0092 1.23631 11.2882 1.10644 11.5854 1.04345C11.8826 0.980465 12.1902 0.986021 12.485 1.0597L16.485 2.0597C16.9177 2.16785 17.3018 2.41752 17.5763 2.76903C17.8508 3.12053 17.9999 3.55371 18 3.9997V18.4377ZM18 18.4377H21M10 2.4377H7C6.46957 2.4377 5.96086 2.64841 5.58579 3.02348C5.21071 3.39856 5 3.90726 5 4.4377V18.4377M13 10.4377H13.01'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};
